import React from 'react'
import Header from './Header'
import Footer from './Footer'

export default function Layout({ children }) {
    return (
        <div style={{height: '100vh'}}>
            <Header />
            {children}
            <Footer />
        </div>
    )
}
